import { ChevronLeftIcon, CrossIcon } from "../Icons";
import { InputV2 } from "../InputV2";
import { Typo } from "../Typo";
import { useAutoFocus } from "./useAutoFocus";
import { RENAME_CHAR_LIMIT } from "./types";
import type { MarketingBannersTranslations } from "./types";

type BannerBottomSheetRenameProps = {
  name: string;
  error: string;
  translations: MarketingBannersTranslations;
  onNameChange: (value: string) => void;
  onBack: () => void;
  onClose: () => void;
};

export const BannerBottomSheetRename = ({
  name,
  error,
  translations,
  onNameChange,
  onBack,
  onClose,
}: BannerBottomSheetRenameProps) => {
  const inputRef = useAutoFocus<HTMLInputElement>();

  return (
    <div className="flex w-full flex-col gap-6 px-4 pb-6">
      <div className="flex items-center justify-between">
        <button
          type="button"
          onClick={onBack}
          className="flex items-center gap-2 text-text-primary"
        >
          <ChevronLeftIcon className="h-4 w-4" />
          <Typo type="headingMD">{translations.rename.title}</Typo>
        </button>
        <button type="button" onClick={onClose} className="text-text-primary">
          <CrossIcon className="h-6 w-6" />
        </button>
      </div>
      <div className="min-h-[112px]">
        <InputV2
          ref={inputRef}
          name="rename-banner-mobile"
          value={name}
          onChange={onNameChange}
          maxLength={RENAME_CHAR_LIMIT}
          characterLimit={RENAME_CHAR_LIMIT}
          error={error}
          showError={!!error}
        />
      </div>
    </div>
  );
};
